import { Routes } from '@angular/router'
import { hasPermissionGuard } from './core/guards/has-permission.guard'
import { PublicComponent } from './layouts/public-layout/public-layout.component'
import { PUBLIC_ROUTES } from './public/features/routes'
import { SecureLayoutComponent } from './layouts/secure-layout/secure-layout.component'
import { SECURE_ROUTES } from './secure/routes'
import { authGuardFn } from '@auth0/auth0-angular'
import { Permissions } from './core/permissions'
import { QuoteStoreService } from './quote-wizard/quote-store.service'
import { ProductSearchModalService } from './secure/features/quote-wizard/components/product-search-modal/product-search-modal.service'
import { QuoteTotalsService } from './quote-wizard/services/quote-totals.service'
import { QuoteSetupService } from './quote-wizard/services/quote-setup.service'
import { QuoteThemeService } from './quote-wizard/services/quote-theme.service'
import { QuoteResourceService } from './quote-wizard/services/quote-resource.service'
import { unsavedChangesGuardFn } from './core/guards/unsaved-changes.guard'
import { subscriptionGuard } from './core/guards/subscription.guard'

export const routes: Routes = [
    // { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: '', redirectTo: '/auth', pathMatch: 'full' },
    {
        path: '',
        component: PublicComponent,
        children: PUBLIC_ROUTES,
    },
    {
        path: '',
        component: SecureLayoutComponent,
        children: SECURE_ROUTES,
        canActivateChild: [authGuardFn, subscriptionGuard],
        // canActivate: [authGuardFn],
    },
    {
        path: 'quote-wizard/start/:templateId/:leadId',
        loadComponent: () =>
            import('./quote-wizard/quote-shell/quote-shell.component').then((m) => m.QuoteShellComponent),
        canDeactivate: [unsavedChangesGuardFn],
        canActivate: [authGuardFn, hasPermissionGuard, subscriptionGuard],
        providers: [
            QuoteStoreService,
            QuoteTotalsService,
            QuoteSetupService,
            QuoteThemeService,
            QuoteResourceService,
            ProductSearchModalService,
        ],
        data: {
            permissions: Permissions.QuoteWizard.Create,
        },
    },
    // {
    //     path: '**',
    //     redirectTo: '/login',
    // },

    {
        path: '**',
        redirectTo: '/error',
    },
]
